import React from "react";
import styled from "styled-components";
import FixaSearch, {
  FixaSearchActions,
} from "@coworker/apprestructured/src/shared/wrappers/FixaSearch/FixaSearch";

const GridContainer = styled.div`
  display: grid;
  width: 100%;
  max-width: 100%;
  box-sizing: border-box;
  grid-template-areas:
    "search close"
    "scanner scanner";
  grid-template-columns: 1fr auto;
  gap: 8px;
  align-items: center;
  padding: 24px 16px;
`;

const SearchBarContainer = styled(FixaSearch)`
  grid-area: search;
`;
const CloseButtonContainer = styled.div`
  grid-area: close;
`;

interface ScannerPageProps {
  onClick: () => void;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onClear: () => void;
  valueString: string;
  translationsSearchString: string;
  autoFocus: boolean | undefined;
  closeButtonComponent?: React.ReactNode;
  onFocus: () => void;
  onBlur: () => void;
  actions?: FixaSearchActions[] | undefined;
}

const SearchBarComponentPresentation: React.FC<ScannerPageProps> = ({
  onClick,
  onChange,
  onClear,
  translationsSearchString,
  valueString,
  autoFocus = false,
  closeButtonComponent,
  onFocus,
  onBlur,
  actions = [],
}) => {
  return (
    <GridContainer>
      <SearchBarContainer
        data-testid="product-search-bar"
        autoFocus={autoFocus}
        id={"product-search"}
        onClick={onClick}
        onChange={onChange}
        placeholder={translationsSearchString}
        value={valueString}
        onClear={onClear}
        focusWithClearButton
        onFocus={onFocus}
        onBlur={onBlur}
        actions={actions}
      />
      {closeButtonComponent && (
        <CloseButtonContainer>{closeButtonComponent}</CloseButtonContainer>
      )}
    </GridContainer>
  );
};

export default SearchBarComponentPresentation;
